/**
 * "+ Create": everything the console can bring into existence — an
 * organization (with its owner), a module in the catalog, a plan.
 *
 * Each entry opens the screen or dialog that already does it (console.js).
 */
import { Link } from 'react-router-dom';
import { Icon } from '../components/Icon.jsx';
import { Popover } from '../components/Popover.jsx';
import { CREATE_ACTIONS, newLabel } from './console.js';

export function QuickCreateMenu({ actions = CREATE_ACTIONS }) {
  return (
    <div className="qc">
      <div className="popover-title">Create</div>
      <div className="qc-groups">
        <div className="qc-group">
          {actions.map((action) => (
            <Link key={action.label} to={action.to} state={action.state} className="qc-item" role="menuitem">
              <Icon name={action.icon} size={15} />
              <span>{newLabel(action.label)}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export function QuickCreate() {
  return (
    <Popover
      label="Create"
      role="menu"
      align="end"
      trigger={({ triggerProps, open }) => (
        <button type="button" className={`topbar-create ${open ? 'is-open' : ''}`} {...triggerProps} title="Create">
          <Icon name="plus" size={16} strokeWidth={2.1} />
          <span className="topbar-create-label">Create</span>
        </button>
      )}
    >
      <QuickCreateMenu />
    </Popover>
  );
}
